import fetch from "../utils/fetch";
//派样记录
export const fetchGrantRecord = (params) =>
  fetch(`/web/record/list`, {
    method: "get",
    params,
  });

//获取用户填写的调查问卷
export const fetchQuestionnaire = (params) => {
  return fetch(`/web/record/questionnaire/${params}`);
};

//查询办卡记录
export const fetchSpdList = (params) => {
  return fetch(`/spd/list`, {
    params,
  });
};

//查询指定用户的访问记录
export const fetchSpdRecord = (params) =>
  fetch(`/spd/user/list`, {
    params,
  });
